const anime = window.anime;

// Get recommendations container and recommendation elements
const recommendationsContainers = document.querySelectorAll('.wp-block-klx-recommendations');

recommendationsContainers.forEach(container => {
    const recommendations = container.querySelectorAll('.wp-block-klx-recommendations-recommendation');
    if (recommendations.length <= 1) return;

    // Create intersection observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Get all recommendation elements and start their animations
                recommendations.forEach((recommendation, index) => {
                    setTimeout(() => {
                        recommendation.style.animationPlayState = 'running';
                    }, index * 100); // 200ms delay between each recommendation
                });
            }
        });
    }, {
        threshold: 0.2, // Trigger when 20% of the element is visible
        rootMargin: '100px' // Add some margin to trigger slightly before the element is in view
    });

    // Start observing
    observer.observe(container);
});

